import { Link } from "react-router";
import NavigationComponent from "../../navigation/navigation.component";
import { MainStyle, AccentStyle, Header1, Background, DescriptionContainer, OppGradient, SingleVideo, Gradient, GeneralLinks, LinkHeader} from "./actualplay.styles";

const ActualPlay = () => {
    
    return(
        <Background>
            <NavigationComponent></NavigationComponent>
            <Gradient></Gradient>
            
             <AccentStyle>
            <DescriptionContainer>
                <Header1>Hex Heist</Header1>
                <h3>Kali Emory (She/They)</h3>
                <h4><GeneralLinks href="https://youtu.be/yFbtLIRgvB4?si=_FpCTPHtHMLhGP4g">Episode 1</GeneralLinks>, <GeneralLinks href="https://youtu.be/05EyhmdK2KM?si=g74U7xlczwz-OdTM">Episode 2</GeneralLinks>, <GeneralLinks href="https://www.youtube.com/watch?v=t3rt3qDF9c0&t=5705s">Episode 3</GeneralLinks>, <GeneralLinks href="https://youtu.be/l_VgyLJMCH4?si=v6naD9OSLbZFi6hh">Episode 4</GeneralLinks></h4>
                <p>A nervous witch gets roped up in several stealing releated endevours with a ragtag group of three other witches.  Why?  To save Burnwood, who they each have their own complex relationship with.  She apppears to be trapped in a powerful hex leaving her immobile.  Can this group save her in time? </p>
            </DescriptionContainer>
                <SingleVideo width="560" height="315" src="https://www.youtube.com/embed/ZqpaaFp5s9s?si=69rQKtHYoApnuMyz" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></SingleVideo>
            </AccentStyle>

          <OppGradient></OppGradient>

            <MainStyle>
            <Header1>Hex Heist: Wandless and Wired</Header1>
           <DescriptionContainer>
            <h3>Kali Emory (She/They)</h3>
            <h4><GeneralLinks href="https://www.youtube.com/watch?v=qeLefGeLfTM&t=2s">Episode 1</GeneralLinks>, <GeneralLinks href="https://youtu.be/qRXaXxErLEM?si=ncXu6g4K8m5_YGD5">Episode 2</GeneralLinks>, <GeneralLinks href="https://youtu.be/1E3y2uzebVA?si=OfwHpxcahc8C-Zkz">Episode 3</GeneralLinks>, <GeneralLinks href="https://youtu.be/in7NKUrcLYQ?si=QxwYb0muc40FP7L9">Episode 4</GeneralLinks>, <GeneralLinks>Episode 5</GeneralLinks>, <GeneralLinks>Episode 6</GeneralLinks></h4>
           
            <p>Kali is meant to face trial for her crimes as a wandless witch.  This trial is the catalyst for the Hex Heist crews next adventure through deadly forest, criminal dens and literal hell.</p>
            </DescriptionContainer>
            <SingleVideo width="560" height="315" src="https://www.youtube.com/embed/qeLefGeLfTM?si=IE--7i4yuUC8eFZT" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></SingleVideo>
               
            </MainStyle>

  <Gradient></Gradient>

            <AccentStyle>
            <DescriptionContainer>
                <Header1>Roll4Luck: ReRise</Header1>
                <h3>Nina (She/They)</h3>
                <h4>Lightening Domain Cleric, Human(?)</h4>
                <p>In this season of Roll4Luck, a new character, Nina is introduced.  She is a very blunt, pastel pink, thicc Queen who does whatever she wants without fear of reprocussions.  However, she is soon forced into a position where she must learn to get along with others, while also trying to hold in her own secrets.</p>
            </DescriptionContainer>
            <SingleVideo width="560" height="315" src="https://www.youtube.com/embed/lry2Yo8ym2E?si=88qieivhY5f3GD8F" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin"  allowfullscreen/>
         
            </AccentStyle>
            <OppGradient></OppGradient>
            <MainStyle>
                <DescriptionContainer>
                <Header1>Roll4Luck: Spark</Header1>
                <h3>Nina (She/They)</h3>
                <h4>Lightening Domain Cleric, Human(?)</h4>
                <p>After breaking through her own internal shackles of her motherly figure and also her mind, Nina embarks on a new journy with her friends.  She is still her blunt self and she still does what she wants, but she's a bit nicer about it! And more protective.  Join her and the Sapphic crew as they embark on a never ending train hesit and also...dimension travel? </p>
                </DescriptionContainer>
                
                <SingleVideo 
                        width="560" 
                        height="315" 
                        src="https://www.youtube.com/embed/xAUmeszJyYE?si=3RnrYulJ6T-8-SVn" 
                        title="YouTube video player" 
                        frameborder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                        referrerpolicy="strict-origin-when-cross-origin" 
                        allowfullscreen/>
                
                 
               
            </MainStyle>
            <Gradient></Gradient>
           

          
            <AccentStyle>
                <Header1>Other TTRPG References</Header1>
                <DescriptionContainer>
                    <LinkHeader><GeneralLinks rel="noopener" target="_blank" href="https://youtu.be/Lmf0e5AQEmw?si=1le-_ggbfjwnooSe">The Black Experience in AP | BHM Event Panel</GeneralLinks></LinkHeader>
                    <LinkHeader><GeneralLinks rel="noopener" target="_blank" href="https://youtu.be/4nkAbgYnetM?si=izVGEFpYk5ByY-1Q">The Black Experience in the TTRPG Community Outside the Lens of Whiteness</GeneralLinks></LinkHeader>
                    <LinkHeader><GeneralLinks rel="noopener" target="_blank" href="https://youtu.be/ottUy6-uYW8?si=z9W2cYNhviTyqwcX">Creator Spotlight with Jess and Brie</GeneralLinks></LinkHeader>
                    <LinkHeader><GeneralLinks rel="noopener" target="_blank" href="https://youtu.be/TZ4NoGLURig?si=puSpIxsehmPDtarj">Murder a la Mode: A Brindlewood Bay Mystery Actual Play</GeneralLinks></LinkHeader>
                    <LinkHeader><GeneralLinks rel="noopener" target="_blank" href="https://youtu.be/j-vAi6ucIkI?si=F3h05D4Fab2Ju3m0">Lost, But Not Alone: The Expanse Transport Union Edition</GeneralLinks></LinkHeader>
                </DescriptionContainer>
            </AccentStyle>
            

           
        </Background>
    )
}

export default ActualPlay;